export default __webpack_public_path__ + "static/media/roadmap-glow1.ee6292db.png";